// Lokalizované texty šablony — slovenská sada, dvojče `locale/cs/common.js`
// (tvar hlídá tools/unit/locale-keys.test.mjs). Strojový překlad z CZ (S3 #399),
// vzorek kontroluje klient před cutoverem SK.

import SHOP from '../../../config/shop.js';
import { page } from '../../modules/pages.js';

export const VO = {
  price: 'Veľkoobchodná cena',
  fromRetail: 'z bežnej ceny',
  save: 'ušetríte',
  savedWithPricelist: 'Ušetríte s cenníkom ',
  savedGeneric: 'Ušetríte s veľkoobchodným cenníkom ',
  pricelistGeneric: 'Veľkoobchodný cenník',
  saleLabel: 'Výpredajová cena',
  saleNote: 'Na výpredajovú cenu sa zľava cenníka ',
  saleNoteEnd: ' neuplatní.',
  saleNoteGeneric: 'Na výpredajovú cenu sa zľava veľkoobchodného cenníka neuplatní.',
  saleLink: 'Ako sa zľava počíta',
  saleCardTag: 'Výpredaj',
  account: 'Môj účet',
  accountPricelist: ', cenník ',
  tag: 'VO',
  levelValueNote: 'zľava z aktuálnych cien',
  rulesTitle: 'Ako sa zľava počíta',
  rules: [
    'Zľava sa počíta z aktuálnej ceny tovaru, pri tovare v akcii z akciovej ceny.',
    'Pri niektorom tovare môže byť zľava nižšia, aby cena neklesla pod našu minimálnu maržu.',
    'Na výpredajové ceny sa zľava neuplatní.',
  ],
  chip: 'Cenník ',
};

export const HOURS = {
  support: 'Zákaznícka podpora',
  supportShort: 'Podpora',
  supportOnline: 'Práve k dispozícii',
  supportOffline: 'Podpora',
  store: 'Otváracie hodiny predajne',
};

export const FAQ = {
  href: page('faq'),
  footerLabel: 'Najčastejšie sa pýtate',
  navLabel: 'Časté otázky',
  tileTitle: 'Časté otázky',
  tileSub: 'Odpovede na jednom mieste',
  eyebrow: 'Časté otázky',
  perexFallback: 'Odpovede na to, na čo sa nás pýtate najčastejšie. Keď tu odpoveď nenájdete, napíšte nám.',
  ctaOrder: 'Stav objednávky',
  ctaMail: 'Napísať na ',
  topicsLabel: 'Témy',
  sideTitle: 'Kam ďalej',
  links: [
    { href: page('shipping'), icon: 'truck', title: 'Doprava a platba', desc: 'Ceny, lehoty a spôsoby platby' },
    { href: page('terms'), icon: 'file', title: 'Obchodné podmienky', desc: 'Úplné znenie lehôt a pravidiel' },
    { href: page('claim'), icon: 'shield', title: 'Reklamačný formulár', desc: 'Založiť reklamáciu online' },
    { href: page('withdrawal'), icon: 'refresh', title: 'Vrátenie do 14 dní', desc: 'Odstúpenie od zmluvy online' },
  ],
  helpTitle: 'Nenašli ste odpoveď?',
  helpText: 'Napíšte nám, ku ktorej téme odpoveď chýba. Odpovieme a doplníme ju aj sem.',
  bandTitle: 'Potrebujete poradiť s výberom?',
  bandText: 'Poradíme s parametrami, dostupnosťou aj náhradnými dielmi.',
  bandMail: 'Napísať e-mail',
};

const LIVE_WEB = SHOP.shop.origin.replace(/^https?:\/\//, '');
export const DEV_NOTICE = {
  barTitle: 'TESTOVACIA VERZIA',
  barText: ' · objednávky odtiaľto k nám nedorazia.',
  barCta: 'Nakupovať na ' + LIVE_WEB + ' →',
  blockTitle: 'Tu objednávku nedokončíte',
  blockText:
    'Ste na testovacej verzii e-shopu ' + SHOP.shop.brand + ', objednávka by k nám nedorazila. Rovnaký tovar nájdete na ' + LIVE_WEB + '.',
  blockCta: 'Prejsť na ' + LIVE_WEB,
};

export const CART_XSELL = {
  title: 'Hodí sa k tomu',
  stock: 'Skladom',
  add: 'Pridať',
  addAria: 'Pridať do košíka: ',
};
